export default "__VITE_PUBLIC_ASSET__c3409afe__"